import React, { useState, useEffect, Suspense } from "react";
import { awsAPIUrlcommon } from "../../apiService";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import $ from "jquery";
import "../../css/admin.css";
const folderName = window.sessionStorage.getItem("homeName");
const Header = React.lazy(() => import("../../" + folderName + "/header"));
const Footer = React.lazy(() => import("../../" + folderName + "/footer"));
const PollList = () => {
    const location = useLocation();
    let data
    const [importData, setImportData] = useState([])
    const [pollListData, setPollListData] = useState([]);
    useEffect(() => {
        if (location?.state) {
            ({ data } = location.state);
            getFullListData(data)
        }
    }, []);
    const getFullListData = (data) => {
        $(".loader").show();
        const apiJson = {
            method: "POST",
            body: JSON.stringify({
                "functionName": "pollHistory",
                "pollId": data
            }),
        };
        awsAPIUrlcommon(apiJson).then((data) => {
            if (data.success === "1") {
                setPollListData(data.result[0])
                // const convertedData = convertData(data.result);
                // setImportData(convertedData);

                $(".loader").hide();
            } else {
                alert("Somethingwent Wrong While Fetching Data")
                $(".loader").hide();
            }
        })
            .catch((error) => {
                console.error("Error sending notification:", error);
                $(".loader").hide()
                // alert("An error occurred while Getting Details");
            });
    };
    function formatDate(timestamp) {
        if (timestamp) {
            const date = new Date(timestamp);
            const day = date.getUTCDate().toString().padStart(2, '0');
            const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
            const year = date.getUTCFullYear();
            const formattedDate = `${day}-${month}-${year}`;
            return formattedDate;
        } else { return "NoData Available" }
    }
    // const formatDateWithTime = (timestamp) => {
    //     const date = new Date(timestamp);
    //     const day = date.getDate().toString().padStart(2, '0');
    //     const month = (date.getMonth() + 1).toString().padStart(2, '0');
    //     const year = date.getFullYear().toString().slice(2);
    //     const formattedDate = `${day}/${month}/${year}`;
    //     const hours = date.getHours().toString().padStart(2, '0');
    //     const minutes = date.getMinutes().toString().padStart(2, '0');
    //     const formattedTime = `${hours}:${minutes}`;

    //     return `${formattedDate} ${formattedTime}`;
    // }
    // const convertData = (data) => {
    //     const transformedData = data.map((poll, i) => (
    //         poll.pollDetails.map(DATA => {
    //             return {
    //                 question: DATA.pollQuestions,
    //                 userData: poll.pollDetails.map(userDetail => {
    //                     console.log(userDetail, "userDetailuserDetailuserDetailuserDetail");
    //                     if (DATA.pollQuestionsId === userDetail.pollQuestionsId) {
    //                         let userDetails = [];
    //                         userDetail.userPollDetails.forEach(data => {
    //                             data.pollUsers.forEach(item => {
    //                                 if (item.answerId === data.answerId) {
    //                                     userDetails.push({
    //                                         answer:data.answer,
    //                                         pollUser: item,
    //                                         answerId: data.answerId
    //                                     });
    //                                 }
    //                             });
    //                         });

    //                         let finalArray = [];
    //                         userDetails.forEach((data, i) => {
    //                             if (data.answerId === data.pollUser.answerId) {
    //                                 let answerUser=[]
    //                                 answerUser.push(data.answer)
    //                                 finalArray.push({
    //                                     ...data.pollUser,
    //                                     answer:answerUser
    //                                 });
    //                             }
    //                         });
    //                         let answersFilter = [];

    //                         finalArray.forEach((data) => {
    //                             // Object to store answers for each user ID
    //                             const userAnswers = {};
                            
    //                             data.userData.forEach((userData) => {
    //                                 const userId = userData.userId;
    //                                 const answer = userData.answer;
                            
    //                                 // Check if user ID already exists in userAnswers
    //                                 if (userAnswers.hasOwnProperty(userId)) {
    //                                     // Append answer to existing entry
    //                                     userAnswers[userId].push(answer);
    //                                 } else {
    //                                     // Create new entry for user ID
    //                                     userAnswers[userId] = [answer];
    //                                 }
    //                             });
                            
    //                             // Convert userAnswers to the desired format and push to answersFilter
    //                             for (const userId in userAnswers) {
    //                                 if (userAnswers.hasOwnProperty(userId)) {
    //                                     const answersString = userAnswers[userId].join(','); // Join answers with comma
    //                                     answersFilter.push({
    //                                         userId: userId,
    //                                         answer: answersString,
    //                                         ...data.pollUser
    //                                     });
    //                                 }
    //                             }
    //                         });
                            
    //                         return answersFilter;
    //                     }
    //                 }).filter(userData => userData !== undefined) // Filter out undefined values
    //             };
    //         })
    //     ));

    //     console.log(transformedData, "transformedDatatransformedDatatransformedData");




    //     // let convertedData = [];
    //     // data.forEach((poll) => {
    //     //     poll.pollDetails.forEach((detail) => {
    //     //         let questionData = {
    //     //             question: detail.pollQuestions,
    //     //             userData: []
    //     //         };
    //     //         detail.userPollDetails.forEach((userDetail) => {
    //     //             userDetail.pollUsers.forEach((user) => {
    //     //                 questionData.userData.push({
    //     //                     userPollCreatedDate: user.userPollCreatedDate,
    //     //                     userDisplayName: user.userDisplayName,
    //     //                     email_id: user.email_id,
    //     //                     mobile_number: user.mobile_number,
    //     //                     answer: userDetail.answer
    //     //                 });
    //     //             });
    //     //         });
    //     //         convertedData.push(questionData);
    //     //     });
    //     // });
    //     return transformedData;
    // };
    // const exportExcelFunction = () => {
    //     const workbook = XLSX.utils.book_new();
    // importData.forEach((items) => {
    //     const wsData = [];
    //     const question = items.question; // Storing question outside the loop
    //     if(!items.length)return; 
    //     wsData.push(["Created Date", "User Name", "Email Id", "Mobile Number", ...items.map(eachData=>eachData.question)]);
    //     // console.log("🚀 ~ items.userData.forEach ~ items:", items)
        
    //     for ( const {userData, question} of items) {
    //         if(!userData.length) {
    //             continue;
    //         }
    //         for ( const item of userData) {
    //             if(!item.length) {
    //                 continue;
    //             }
    //             item.forEach((itemsData) => {
    //                  console.log(itemsData, "itemsDataitemsDataitemsDataitemsData");
    //                 wsData.push([
    //                     itemsData.userPollCreatedDate,
    //                     itemsData.userDisplayName,
    //                     itemsData.email_id,
    //                     itemsData.mobile_number,
    //                     itemsData.answer,
    //                 ]);
    //             })
    //         }
    //     }
    //     const ws = XLSX.utils.aoa_to_sheet(wsData);
    //     XLSX.utils.book_append_sheet(workbook, ws, question); // Using the stored question variable
    // });

    // XLSX.writeFile(workbook, "survey_data.xlsx");
    //     // const excelData = [];
    //     // importData.forEach((item) => {
    //     //     const { question, userData } = item;
    //     //     userData.forEach((user) => {
    //     //         const { userPollCreatedDate, userDisplayName, email_id, mobile_number, answer } = user;
    //     //         const time = formatDateWithTime(userPollCreatedDate); // Call formatDateWithTime for each timestamp
    //     //         excelData.push({
    //     //             'Created Date': time, // Use the formatted time
    //     //             'User Name': userDisplayName,
    //     //             'Email Id': email_id,
    //     //             'Mobile Number': mobile_number,
    //     //             [question]: answer
    //     //         });
    //     //     });
    //     // });
    //     // const worksheet = XLSX.utils.json_to_sheet(excelData);
    //     // const workbook = XLSX.utils.book_new();
    //     // XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    //     // XLSX.writeFile(workbook, 'poll_data.xlsx');
    // };
    return (
        <div className="purpleWrap bg-clr-wthHead">
            <Suspense fallback={<div>Waiting...</div>}>
                <section>
                    <Header />
                    <div className="loader"></div>
                    <div className="container mb-5">
                        <div>
                            <ul className="breadcrum-adminMangmnt">
                                <li>
                                    <a href="/admin/dashboard">Dashboard</a>
                                </li>
                                <li>
                                    <a href="/adminManagement/poll-list" >
                                        Poll List
                                    </a>
                                </li>
                                <li>
                                    <a href="" className="current">
                                        Poll History
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="head-hospMangmntList mb-4">Poll History Details
                            <div className="AddNewHspbtnDiv w-auto pull-right">
                                <a href="/adminManagement/create-poll" className="addnewhspbtn mr-3">
                                    Add New Poll
                                </a>
                                {/* {pollListData?.PollId &&
                                    <span className="addnewhspbtn mr-3" onClick={exportExcelFunction} >
                                        Export Excel
                                    </span>} */}
                            </div>
                        </div>
                        {pollListData?.PollId ?
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card mb-3">
                                        <div className="card-header py-1 border-0">
                                            <p className="mb-1"> <span className="span_medium">Title : </span>{pollListData.pollName}</p>
                                            {pollListData?.pollDescription &&
                                                <p className="mb-1"><span className="span_medium"> Description : </span>{pollListData.pollDescription}</p>}
                                            <p className="mb-1"><span className="span_medium"> Created On : </span>{formatDate(pollListData.pollCreatedOn)}</p>
                                            <p className="mb-1"><span className="span_medium"> Start Date : </span>{formatDate(pollListData.pollStartDate)}</p>
                                            <p className="mb-1"><span className="span_medium"> End Date : </span>{formatDate(pollListData.pollEndDate)}</p>
                                        </div>
                                    </div>
                                </div>
                                {pollListData?.pollDetails?.map((data, i) => (
                                    <div className="col-md-12 mb-3">
                                        <div className="card">

                                            <div className="card-body p-0">
                                                <div className="card border-0">
                                                    <div className="card-header py-1">
                                                        <p className="mb-0"> <span className="span_medium"> Question {i + 1} :</span> {data.pollQuestions}</p>
                                                    </div>
                                                    <div className="card-body pb-0 pt-2">
                                                        <p className=""><span className="span_medium">Question Answer Type : </span>{data.questionAnswerType}</p>
                                                        {/* ////////////////////////////// */}
                                                        {data.userPollDetails.map((data, j) => (
                                                            <div className="card mb-12 mt-2">
                                                                <div className="card-header py-1 border-0 " >
                                                                    <div className="row ">
                                                                        <p className="mb-0 col-md-6" style={{ color: "#a56565" }}> <span className="span_medium">  Option {1 + j} :</span> {data.answer}</p>
                                                                        <p className="mb-0 col-md-6 text-right"> <span className="span_medium ">  Count:</span>{data.totalCount}</p>
                                                                    </div>
                                                                    <div className="row pollhistoryHeight">
                                                                        {data.pollUsers.map((item, k) => (
                                                                            <div className="col-md-4 card mb-2 mt-2 p-0" style={{ borderColor: "#2278c3" }}>
                                                                                <div className="card-header py-1 border-1">
                                                                                    <p className="mb-0"> <span className="span_medium">User Name {1 + k} :</span> {item.userDisplayName}</p>
                                                                                    <p className="mb-0"> <span className="span_medium"> MobileNumber: </span>{item.mobile_number}</p>
                                                                                </div>
                                                                            </div>))}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        ))}
                                                        {/* /////////////////////////////////////////// */}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </div> : <div className="text-center">No DataFound</div>}
                    </div>
                    {folderName !== null && <Footer />}
                </section>
            </Suspense>
        </div>
    );
}

export default PollList;
